import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-heavyrain.svg";
import * as styles from "./Icon.module.scss";

type WeatherHeavyProps = React.SVGProps<SVGSVGElement>;

export const WeatherHeavy = ({ className, ...props }: WeatherHeavyProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
